/** Keep sidebar / attendance nav in sync with Extra Work → Enable Overtime. */

export const OT_HOURS_ALLOCATION_CONFIG_EVENT = "extra-work-config-changed";

export function otHoursAllocationEnabledFromExtraWork(cfg) {
  if (cfg?.overtime && typeof cfg.overtime.enabled === "boolean") {
    return Boolean(cfg.overtime.enabled);
  }
  return Boolean(cfg?.processing?.ot_hours_allocation_enabled);
}

export function broadcastOtHoursAllocationEnabled(enabled) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(OT_HOURS_ALLOCATION_CONFIG_EVENT, {
      detail: { enabled: Boolean(enabled) },
    })
  );
}

export function broadcastOtHoursAllocationFromExtraWork(cfg) {
  broadcastOtHoursAllocationEnabled(otHoursAllocationEnabledFromExtraWork(cfg));
}
